import React, { Component } from "react";
import { Route } from "react-router-dom";
import { connect } from "react-redux";

require("../styles/styles.scss");

class App extends Component {
  render() {
    let { component: AppComponent, ...restProps } = this.props;
    return (
      <Route
        {...restProps}
        render={(props) => {
          return <AppComponent {...{ ...props, ...restProps }} />;
        }}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isAuth: state.app.isAuth,
    loginName: state.app.loggedUser.loginName,
  };
};

export default connect(mapStateToProps)(App);
